import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Divider, Tabs, Typography } from 'antd';
import { selectPortfoliosWithSignals } from '../../store/slices/portfolios.slice';
import SignalCollectionTable from './components/SignalCollectionTable';
import PageHeader from '../../layouts/PageHeader';
import { iconMapping } from '../../configs/AppsConfig';
import PortfolioSignals from "./components/PortfolioSignals";
import {StarRounded} from "@mui/icons-material";

const { TabPane } = Tabs;

const TradingSignals = () => {
    const activePortfolios = useSelector(selectPortfoliosWithSignals);
    const inactivePortfolios = useSelector((state) => selectPortfoliosWithSignals(state, {inUse: false}));
    const [selectedPortfolioId, setSelectedPortfolioId] = useState(null);
    const [isEditorVisible, setIsEditorVisible] = useState(false);

    useEffect(() => {
        if (selectedPortfolioId) {
            setIsEditorVisible(true);
        }
    }, [selectedPortfolioId]);
    // const portfoliosWithUnackedSignals = filterPortfoliosWithSignals(portfolios);

    const handleViewPortfolioSignals = (portfolioID) => {
        // This check prevents the editor from closing and reopening
        // if the same portfolio is clicked twice in a row.
        if (portfolioID !== selectedPortfolioId) {
            setIsEditorVisible(false); // Ensure component unmounts when switching portfolios
            setTimeout(() => setSelectedPortfolioId(portfolioID), 10); // Delay to allow drawer close animation
        }
    };

    return (
        <div>
            <PageHeader title={'Signals'} logoUrl={iconMapping.signals} />
            <div className={'content-container'}>
                <div className={'content-wrapper p-2'}>
                    <Typography.Title level={4}>
                        Portfolios In Use (<StarRounded/>)
                    </Typography.Title>
                    <SignalCollectionTable portfolios={activePortfolios} onViewPortfolioSignals={handleViewPortfolioSignals} />
                    <Divider/>
                    <Typography.Title level={4}>
                        Portfolios In List
                        <Typography.Text style={{paddingLeft: 10}} strong>This includes portfolios with recent changes that exist in your Portfolios list, but are not currently active</Typography.Text>

                    </Typography.Title>
                    <SignalCollectionTable portfolios={inactivePortfolios} onViewPortfolioSignals={handleViewPortfolioSignals} />
                </div>
                {selectedPortfolioId && (
                    <>
                        <PortfolioSignals
                            key={selectedPortfolioId} // Keying on the portfolioId forces re-render
                            portfolioId={selectedPortfolioId}
                        />

                    </>
                )}
            </div>
        </div>
    );
};

export default TradingSignals;
